import { render, staticRenderFns } from "./VideosRu.vue?vue&type=template&id=371fe6be&"
import script from "./VideosRu.vue?vue&type=script&lang=js&"
export * from "./VideosRu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports